import { render, staticRenderFns } from "./base-tabs.vue?vue&type=template&id=5488ce1c&scoped=true"
import script from "./base-tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./base-tabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-tabs.vue?vue&type=style&index=0&id=5488ce1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488ce1c",
  null
  
)

export default component.exports